import { Group, Pagination as MantinePagination } from "@mantine/core";

interface PaginationProps {
	currentPage: number;
	totalPages: number;
	onPageChange: (page: number) => void;
}

function Pagination({
	currentPage,
	totalPages,
	onPageChange,
}: PaginationProps) {
	if (totalPages <= 1) return null;

	return (
		<Group
			justify="center"
			mt="lg">
			<MantinePagination
				value={currentPage}
				onChange={onPageChange}
				total={totalPages}
			/>
		</Group>
	);
}

export default Pagination;
